module.exports = __webpack_public_path__ + "img/eLearning_content_img_02.ae939aea.jpg";